module.exports = __webpack_public_path__ + "img/chinesecompany100.7bb6398f.png";